<template>
  <div class="ws-info">
    <WsText001
      v-if="title"
      h5
      bold
    >
      <i
        v-if="leadingIcon "
        :class="leadingIcon"
      />{{ title }}
    </WsText001>
    <div v-if="(value==null||value.length==0||(typeof(value)=='object'&&Object.keys(value).length===0))">
      -
    </div>
    <div
      v-else-if="type==='text'"
      class="ws-info__text"
    >
      <WsInfoText
        class="mt-8"
        :value="value"
      />
    </div>
    <WsInfoFiles
      v-else-if="type==='files'"
      :two-item="twoItem"
      :three-item="threeItem"
      :narrow="narrow"
      :attaches="value"
    />
  </div>
</template>

<script>
export default {
  name: "WsInfo",
  props: {
    leadingIcon: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "",
    },
    threeItem: {
      type: Boolean,
      default: false,
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
};
</script>